import axios, { AxiosPromise } from 'axios'
import { CREDITS_API_URL, getApiUrl } from '../util/api/api'
import type { JobPostingProduct } from '../../state/reducers/entitlement/entitlement'
import type { Upgrade } from '../../state/reducers/packages/packages'
import { SelectableUpgradesSchema } from '../../schema/credit'

type DefinitionData = {
  jobPostingDefinition: JobPostingProduct,
  jobUpgradeDefinitions: Array<Upgrade>
}

export const getSelectableUpgrades = (definitionData: DefinitionData) =>
  axios.post(getApiUrl(`${CREDITS_API_URL}/getSelectableUpgrades`), definitionData)

export const getSelectableUpgrades2 = (definitionData: DefinitionData): AxiosPromise<SelectableUpgradesSchema> =>
  axios.post<SelectableUpgradesSchema>(getApiUrl(`${CREDITS_API_URL}/selectable-upgrades`), definitionData)
